import { Spin } from 'antd';

import { useMaterialPage } from './hooks';

import MaterialChangeModal from '~organisms/MaterialChangeModal';
import MaterialsList from '~organisms/MaterialsList';
import MaterialsTemplate from '~templates/Materials';

const MaterialPage = () => {
  const {
    isFetchingMaterials,
    materialsList,
    selectedMaterial,
    selectMaterialId,
    closeModal,
    overwritingMaterialName,
    overwriteSelectedMaterial,
  } = useMaterialPage();

  return isFetchingMaterials ? (
    <Spin style={{ fontSize: 24 }} />
  ) : (
    <>
      <MaterialsTemplate
        materialsSlot={
          <MaterialsList
            data={{ materials: materialsList }}
            selectedMaterialId={selectedMaterial?.id}
            onSelectMaterial={selectMaterialId}
          />
        }
      />
      <MaterialChangeModal
        materialName={overwritingMaterialName}
        onCancel={closeModal}
        onConfirm={overwriteSelectedMaterial}
      />
    </>
  );
};

export default MaterialPage;
